import React, { useEffect } from 'react'
import { IonContent, IonGrid, IonHeader, IonRow, IonTitle, IonToolbar } from '@ionic/react'
import { Link } from 'react-router-dom'
import { trackPage } from '../helpers/tracker_actions'

const ErrorPage = () => {

  useEffect(() => {
    trackPage('Error_Page')
  }, [])

  return (
    <>
      <IonHeader class="modalHeader" slot="fixed">
        <IonToolbar>
          <IonTitle>Felmeddelande</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonGrid class="infoArea flex flex-col justify-center items-center p-8">
          <IonRow>
            <h2 className="color_red mb-2 ">
              Något gick snett!
            </h2>
          </IonRow>
          <IonRow>
            <h2 className="mb-2">Du har inte tillåtelse att se denna sida.</h2>
          </IonRow>
          <IonRow>
            <p className="text_center">
            Om du fick en inbjudan: Säkerställ att du är inloggad med samma mailadress som fick inbjudan. Om ja, kontakta den som skickat inbjudan för att få en ny länk.
            </p>
          </IonRow>
          <IonRow>
            <Link to="/walk/home" className="my-4">Gå till hitta promenader</Link>
          </IonRow>
        </IonGrid>
      </IonContent>
    </>
  )
}

export default ErrorPage